import { Schema as S } from "effect";

export const ListScheduleTypesRequestSchema = S.Struct({
  sort: S.optional(S.String),
  page: S.Number,
  itemsPerPage: S.Number,
  noCountLimit: S.Union([S.Literal("true"), S.Literal("false")]),
  creationDate: S.optional(S.String),
  creationDate_lt: S.optional(S.String),
  creationDate_gt: S.optional(S.String),
});

export type ListScheduleTypesRequest = S.Schema.Type<
  typeof ListScheduleTypesRequestSchema
>;
